import { render } from "./TheDisplay.vue?vue&type=template&id=40846add&scoped=true"
import script from "./TheDisplay.vue?vue&type=script&lang=js"
export * from "./TheDisplay.vue?vue&type=script&lang=js"

import "./TheDisplay.vue?vue&type=style&index=0&id=40846add&scoped=true&lang=css"

import exportComponent from "/home/guilh/Milhagem/Telemetria/dt2-telemetria-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40846add"]])

export default __exports__